import { memo } from 'react'
import './index.scss'

type LicencePlate = {
  label: string
}

const LicencePlate = memo(({ label }: LicencePlate) => {
  return (
    <div className="LicencePlate">
      {label}
    </div>
  )
})

export default LicencePlate
